import { memo } from 'react'

type AllowedTag = 'div' | 'h2' | 'li' | 'p' | 'span'

export interface Props {
  as?: AllowedTag,
  className?: string,
  value: string,
  dataTest?: string
}

const Html = ({ as = 'span', className, value, dataTest }: Props) => {
  const htmlData = { __html: value }
  const Tag = as

  return <Tag className={className} dangerouslySetInnerHTML={htmlData} data-test={dataTest} />
}

export default memo(Html)
